<template>
  <rest-list-action
    icon="el-icon-copy-document"
    :title="$t('Snippet_Action_Copy')"
    :click="click"
  />
</template>

<script>
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionUpdate',

  components: { RestListAction },

  props: {
    route: {
      type: Object,
      required: true
    }
  },

  methods: {
    click() {
      this.$router.push(this.route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/snippets/components/SnippetActionCopy.vue